/**
 * 所有内置插件的集合
 * deprecated => thorn、Barrage
 */
import log from 'loglevel';
import Capture from './Capture';
import Fullscreen from './Fullscreen';
import I18N from './I18n';
import Lag from './Lag';
import Marquee from './Marquee';
import PlaybackRate from './PlaybackRate';
import Reporter from './Reporter';
import Scheduler from './Scheduler';
import Switcher from './Switcher';
import Watermark from './Watermark';
import Pursue from './Pursue';
import PlayCurrentTime from './PlayCurrentTime';
import LiveTimeshift from './LiveTimeshift';
import VodMultiSubtitle from './VodMultiSubtitle';
import LiveMultiSubtitle from './LiveMultiSubtitle';
import Poster from './poster';
import Danmaku from './Danmaku';
import PictureInPicture from './PictureInPicture';

let PluginMap = new Map();

PluginMap.set(I18N.type, I18N);
PluginMap.set(Fullscreen.type, Fullscreen);
PluginMap.set(Capture.type, Capture);
PluginMap.set(PlaybackRate.type, PlaybackRate);
PluginMap.set(Danmaku.type, Danmaku);

if (process.env.PF === 'vhall') {
  // 注册插件 - 调度
  PluginMap.set(Scheduler.type, Scheduler);
  // 切线
  PluginMap.set(Switcher.type, Switcher);
  // 封面
  PluginMap.set(Poster.type, Poster);
  // 卡顿
  PluginMap.set(Lag.type, Lag);
  // 日志上报
  PluginMap.set(Reporter.type, Reporter);
  // 跑马灯
  PluginMap.set(Marquee.type, Marquee);
  // 水印
  PluginMap.set(Watermark.type, Watermark);
  // 追播
  PluginMap.set(Pursue.type, Pursue);
  // 直播暂停后播放逻辑优化
  PluginMap.set(PlayCurrentTime.type, PlayCurrentTime);
  // 移时直播
  PluginMap.set(LiveTimeshift.type, LiveTimeshift);
  // 回放字幕
  PluginMap.set(VodMultiSubtitle.type, VodMultiSubtitle);
  // 直播字幕
  PluginMap.set(LiveMultiSubtitle.type, LiveMultiSubtitle);
  // 画中画
  PluginMap.set(PictureInPicture.type, PictureInPicture);
}

export default PluginMap;
